<template>
  <div class="v-carousel">
    <el-carousel height="305px" :autoplay="false">
      <el-carousel-item>
        <div class="banner-wrap banner1">
          <div class="content">
            <h1>结构抗震性能设计软件 PBSD</h1>
            <p class="global_descp">提供全套超限分析解决方案及优质技术服务，辅助工程师高效完成超限分析，协助研究人员开展抗震课题研究。</p>
            <button class="pr-btn" @click="download">下载 PBSD</button>
          </div>
        </div>
      </el-carousel-item>
      <!-- <el-carousel-item> -->
        <!-- <div class="banner-wrap banner2">
          <div class="content">
            <h3>PBSD 1.0</h3>
            <h4>PBSD 1.0 Version</h4>
            <p class="tip">试用期内免费开放所有功能，提供无偿技术支持</p>
            <p class="old-price"></p>
            <button class="pr-btn" @click="download">下载 PBSD 1.0</button>
          </div>
        </div> -->
      <!-- </el-carousel-item> -->
    </el-carousel>
  </div>
</template>

<script>
import ENV from '@/config/env.config'

export default {
  name: 'VCarousel',
  methods: {
    pay() {
      this.$router.push({ path: '/pay/' })
    },
    download() {
      window.location.href = ENV.wwwURL + this.$store.getters.downloadUrl
    }
  }
}
</script>

<style lang="less" scoped>
.banner-wrap {
  // box-sizing: border-box;
  background-color: #5670b7;
  background-image: url('../assets/slide1.png');
  min-height: 300px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  font-family: "Microsoft YaHei";
}
.banner1 {
  // margin-top: 20px;
  .content {
    max-width: 500px;
    margin-top: 40px;
  }
  h1 {
    font-size: 26px;
    line-height: 28px;
    padding-bottom: 25px;
  }
  .global_descp {
    text-align: justify;
  }
  p {
    font-size: 15px;
    line-height: 23px;
    padding-bottom: 25px;
  }
  .pr-btn {
    padding: 7px 40px;
    font-size: 20px;
    font-weight: 600;
    font-family: "Microsoft YaHei";
  }
}

.banner2 {
  background-image: url('../assets/bg2.png');
  // h2 {
  //   font-size: 30px;
  //   font-weight: 600;
  //   line-height: 42px;
  //   margin-bottom: 4px;
  //   margin-top: 8px;
  // }
  .content {
    margin-top: 15px;
  }
  h3 {
    // font-size: 26px;
    // line-height: 28px;
    // padding-bottom: 20px;
    font-size: 30px;
    font-weight: 600;
    line-height: 42px;
    margin-bottom: 2px;
    margin-top: 8px;
  }
  h4 {
      font-size: 19px;
      line-height: 26px;
      margin-bottom: 20px;
    }
  .tip {
    //font-size: 20px;
    //line-height: 28px;
    //padding-bottom: 5px;
      font-size: 30px;
      font-weight: 600;
      line-height: 44px;
      margin-bottom: 25px;
  }
  .old-price {
    text-decoration: line-through;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 20px;
  }
  .pr-btn {
    padding: 7px 40px;
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
